<div class="row mt-4">
  <div class="col-12">
    <p-textarea
      [formControl]="this.notesForm.controls.content"
      id="content"
      name="content"
      label="Description"
      [maxLength]="65000"
      [rows]="15"
      [showCounter]="true"
      (input)="onContentChanged($event)"
    ></p-textarea>
  </div>
</div>
